import { makeStyles } from '@material-ui/core';
import * as colours from 'colours';

export const useDividerStyles = makeStyles((theme) => ({
  vertical: {
    backgroundColor: (props) =>
      props.color ? props.color : colours.VERY_LIGHT_GRAY,
    width: (props) => (props.width ? props.width : '6px'),
    height: (props) => (props.height ? props.height : '96%'),
  },
  horizontal: {
    backgroundColor: (props) =>
      props.color ? props.color : colours.VERY_LIGHT_GRAY,
    height: (props) => (props.height ? props.height : '6px'),
    marginTop: (props) => (props.marginTop ? props.marginTop : '48px'),
    marginBottom: (props) => (props.marginBottom ? props.marginBottom : '0px'),
  },
}));
